import { isAndroidWebView } from "@/lib/platform";

export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=host.emergent.ilreport.twa";

// Iter 144: badge "Disponibile su Google Play" (nascosto dentro l'app Android stessa)
export function GooglePlayBadge({ dark = false, className = "" }) {
  if (isAndroidWebView()) return null;
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-play-badge"
      className={`inline-flex items-center gap-2.5 rounded-lg border px-3.5 py-2 transition-colors ${
        dark ? "bg-black border-white/30 text-white hover:border-white/60" : "bg-black border-black text-white hover:bg-slate-800"
      } ${className}`}
      aria-label="Disponibile su Google Play"
    >
      <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden="true">
        <path fill="#34A853" d="M3.6 1.8 13.7 12 3.6 22.2c-.4-.2-.6-.7-.6-1.3V3.1c0-.6.2-1.1.6-1.3Z" />
        <path fill="#FBBC04" d="m17.1 15.4-3.4-3.4 3.4-3.4 4.1 2.3c1.1.6 1.1 1.6 0 2.2l-4.1 2.3Z" />
        <path fill="#4285F4" d="M13.7 12 3.6 1.8c.3-.2.8-.1 1.3.2l12.2 6.6-3.4 3.4Z" />
        <path fill="#EA4335" d="m13.7 12 3.4 3.4-12.2 6.6c-.5.3-1 .4-1.3.2L13.7 12Z" />
      </svg>
      <span className="leading-tight text-left">
        <span className="block text-[9px] uppercase tracking-wider opacity-80">Disponibile su</span>
        <span className="block text-sm font-bold -mt-0.5">Google Play</span>
      </span>
    </a>
  );
}
